/* eslint-disable no-console */
/* eslint-disable no-param-reassign */
/* eslint-disable max-len */
/* eslint-disable no-underscore-dangle */
import { useState, useEffect } from 'react';
import moment from 'moment';
import { toastSuccess, toastError } from '../../../../redux/actions/alertActions';
import examServices from '../../../../redux/services/examServices';
import groupServices from '../../../../redux/services/groupServices';
import elearningDetailsServices from '../../../../redux/services/elearningDetailsServices';
import companyServices from '../../../../redux/services/companyServices';
import { determineExamType, withoutSubjectModalities } from '../../../../helpers/utils';

const useExam = (companyId, examList, updateExamData, semestersList) => {
  const [subjects, setSubjects] = useState([]);

  const getAcademicYearBounds = () => {
    const now = new Date();
    const currentYear = now.getFullYear();

    // Si on est avant septembre → l'année académique a commencé l'année précédente
    const startYear = now.getMonth() < 8 ? currentYear - 1 : currentYear;

    const yearBegin = new Date(startYear, 8, 1); // 1 septembre
    const yearEnd = new Date(startYear + 1, 8, 1); // 1 septembre année suivante

    return { yearBegin, yearEnd };
  };

  const isExamUsed = (subjectId) => {
    const { yearBegin, yearEnd } = getAcademicYearBounds();

    return examList.some((exam) => {
      const examBegin = new Date(exam.examBegin);
      const examEnd = new Date(exam.examEnd);

      return (
        exam.examSubject !== null
        && exam.examSubject?._id?.toString() === subjectId.toString()
        && examBegin <= yearEnd
        && examEnd >= yearBegin
      );
    });
  };

  useEffect(() => {
    if (subjects.length <= 0) {
      examServices.getExams()
        .then((subjectsArr) => {
          companyServices.getCompanyDataById(companyId)
            .then((companyData) => {
              const sanitizedSubjectsArr = [];
              subjectsArr.forEach((subject) => {
                if (subject.targets.includes(companyData.adminData.type)) {
                  sanitizedSubjectsArr.push(subject);
                }
              });
              setSubjects(sanitizedSubjectsArr);
            });
        });
    }
  }, []);

  const addExam = (form, catchUp) => {
    if (form.beginDate >= form.endDate) {
      toastError('La date de début de l\'examen doit être avant la date de fin.');
      return;
    }
    let subject = null;
    if (withoutSubjectModalities.includes(form.modality.value) === false) {
      let filteredSubjects = [...subjects];
      if (form.modality.value.includes('Sur table') || form.modality.value.includes('Sur la plateforme - Test de connaissance')) {
        if (form.modality.value.includes('Sur table')) {
          filteredSubjects = subjects.filter((subj) => subj.duration.includes(moment(new Date(form.endDate)).diff(moment(new Date(form.beginDate)), 'minutes')));
        } else if (form.modality.value.includes('Sur la plateforme - Test de connaissance') || form.modality.value.includes('Sur la plateforme - Test de placement')) {
          filteredSubjects = subjects.filter((subj) => subj.duration.includes(form.duration.value));
        }
      }
      filteredSubjects.forEach((_subject) => {
        if (determineExamType(form.modality.value) !== 3 && determineExamType(form.modality.value) !== 5
          && _subject.type === determineExamType(form.modality.value)
          && isExamUsed(_subject._id) === false) {
          subject = _subject;
        } else if (determineExamType(form.modality.value) === 3 && _subject.type === 3) {
          subject = _subject;
        } else if (determineExamType(form.modality.value) === 5 && _subject.type === 5) {
          subject = _subject;
        } else if (determineExamType(form.modality.value) === 6 && _subject.type === 6) {
          subject = _subject;
        }
      });
    }
    if (subject === null && withoutSubjectModalities.includes(form.modality.value) === false) {
      toastError('Pas de sujets disponibles');
      return;
    }
    examServices.postExam(companyId, form.semester.value, {
      catchUp,
      duration: (withoutSubjectModalities.includes(form.modality.value)
        || determineExamType(form.modality.value) === 3
        || determineExamType(form.modality.value) === 5
        || form.modality.value.includes('Oral')
        || form.modality.value.includes('Sur table')
      )
        ? moment(new Date(form.endDate)).diff(moment(new Date(form.beginDate)), 'minutes')
        : form.duration.value,
      modality: form.modality.value,
      EWCorrect: (
        form.modality.value !== 'Sur la plateforme - Test de connaissance 60 minutes'
        && form.modality.value !== 'Sur la plateforme - Test de connaissance 60 minutes'
        && form.modality.value !== 'Sur la plateforme - Test de placement')
        ? form.EWCorrect
        : false,
      examSubject: withoutSubjectModalities.includes(form.modality.value) ? null : subject._id,
      examBegin: form.beginDate,
      examEnd: form.endDate,
      deliveryDate: form.deliveryDate,
      status: {
        name: null,
        createdAt: Date.now(),
        updatedAt: Date.now(),
      },
    })
      .then(() => {
        updateExamData();
        toastSuccess('Examen ajouté.');
      })
      .catch(() => {
        toastError('Problème lors de l\'ajout de l\'examen.');
      });
  };

  const updateExam = (newData, oldExamData) => {
    if (newData.examBegin >= newData.examEnd) {
      toastError('La date et l\'heure de début de l\'examen doivent être avant la date et l\'heure de fin.');
      return;
    }
    semestersList.forEach((sem) => {
      if (newData.semester === sem.value) {
        newData.semester = sem;
      }
    });
    let subject = newData.examSubject;
    if (newData.modality.value !== oldExamData.modality) {
      if (withoutSubjectModalities.includes(newData.modality.value) === false) {
        let filteredSubjects = [...subjects];
        if (newData.modality.value.includes('Sur table') || newData.modality.value.includes('Sur la plateforme - Test de connaissance')) {
          if (newData.modality.value.includes('Sur table')) {
            filteredSubjects = subjects.filter((subj) => subj.duration.includes(moment(new Date(newData.examEnd)).diff(moment(new Date(newData.examBegin)), 'minutes')));
          } else if (newData.modality.value.includes('Sur la plateforme - Test de connaissance') || newData.modality.value.includes('Sur la plateforme - Test de placement')) {
            filteredSubjects = subjects.filter((subj) => subj.duration.includes(newData.duration.value));
          }
        }
        filteredSubjects.forEach((_subject) => {
          if (determineExamType(newData.modality.value) !== 3 && determineExamType(newData.modality.value) !== 5
            && _subject.type === determineExamType(newData.modality.value)
            && isExamUsed(_subject._id) === false) {
            subject = _subject;
          } else if (determineExamType(newData.modality.value) === 3 && _subject.type === 3) {
            subject = _subject;
          } else if (determineExamType(newData.modality.value) === 5 && _subject.type === 5) {
            subject = _subject;
          } else if (determineExamType(newData.modality.value) === 6 && _subject.type === 6) {
            subject = _subject;
          }
        });
      }
      if (subject === null && withoutSubjectModalities.includes(newData.modality.value) === false) {
        toastError('Plus de sujets disponibles');
        return;
      }
    }

    const newDataObj = {
      catchUp: newData.catchUp,
      duration: (withoutSubjectModalities.includes(newData.modality.value)
        || determineExamType(newData.modality.value) === 3
        || determineExamType(newData.modality.value) === 5
        || newData.modality.value.includes('Oral')
        || newData.modality.value.includes('Sur table')
      )
        ? moment(new Date(newData.examEnd)).diff(moment(new Date(newData.examBegin)), 'minutes')
        : newData.duration?.value,
      modality: newData.modality.value,
      EWCorrect: (
        newData.modality.value !== 'Sur la plateforme - Test de connaissance 60 minutes'
        && newData.modality.value !== 'Sur la plateforme - Test de connaissance 60 minutes'
        && newData.modality.value !== 'Sur la plateforme - Test de placement')
        ? newData.EWCorrect
        : false,
      examSubject: withoutSubjectModalities.includes(newData.modality.value) ? null : subject._id,
      examBegin: newData.examBegin,
      examEnd: newData.examEnd,
      deliveryDate: newData.deliveryDate,
      status: {
        name: null,
        createdAt: Date.now(),
        updatedAt: Date.now(),
      },
    };

    if (newData.duration?.value) {
      newDataObj.duration = newData.duration.value;
    }

    elearningDetailsServices.updateElearningOption(oldExamData._id, newDataObj)
      .then(() => {
        updateExamData();
        toastSuccess('Examen modifié avec succès');
      })
      .catch(() => toastError('Problème lors de la mise à jour de l\'examen.'));
  };

  const deleteExam = (oldData) => {
    groupServices.deleteExam(oldData._id)
      .then(() => {
        updateExamData();
        toastSuccess('L\'examen a bien été retiré.');
      })
      .catch(() => toastError('Problème lors de la suppression de l\'examen'));
  };

  return {
    addExam,
    updateExam,
    deleteExam,
  };
};

export default useExam;
